const option = [
    {
        name: 'person1',
        width: 77,
        height: 211,
        top:260,
        left:5845,
        viewIndex:0,
    },
    {
        name: 'person2',
        width: 136,
        height: 256,
        top:392,
        left:11508,
        talk_index:'0',
    },

    {
        name: 'person3',
        width: 220,
        height: 300,
        top:440,
        left:13720,
        opc:0.6,
        viewIndex:1,
    },

    {
        name: 'person4',
        width: 147,
        height: 196,
        top:472,
        left:4585,
        viewIndex:2,
    },

    {
        name: 'person5',
        width: 216,
        height: 500,
        top:552,
        left:17422,
        talk_index:'1',
    },

    {
        name: 'person6',
        width: 207,
        height: 191,
        top:571,
        left:9269,
        viewIndex:3,
    },

    {
        name: 'person7',
        width: 145,
        height: 191,
        top:392,
        left:7213,
        viewIndex:4,
    },

    {
        name: 'person8',
        width: 120,
        height: 216,
        top:420,
        left:10561,
        viewIndex:5
    },

    {
        name: 'person9',
        width: 92,
        height: 190,
        top:301,
        left:8369,
        viewIndex:6
    },

    {
        name: 'person10',
        width: 328,
        height: 398,
        top:542,
        left:27000,
        viewIndex:7
    },

]

export default option;